import { gifsPath, imagePath, videoPath } from "../../../../utils/imagePath";

export const SpatialGridSuperchargeData = [
  {
    title: 'Teams, Projects & Folders',
    desc: 'Create teams and organize your designs & projects.',
    img: imagePath?.superChargeTeam,
  },
  {
    title: 'Templates Library',
    desc: 'A repository of ready to use assets and templates.',
    img: imagePath?.superChargeLibrary,
  },
  {
    title: 'Module Automation',
    desc: 'Build dynamic training modules, demos & walkthroughs',
    img: imagePath?.superChargeAutomation,
  },
  {
    title: 'Multiplayer',
    desc: 'Multiplayer interaction within an experience.',
    img: imagePath?.superChargeMultiplayer,
  },
  {
    title: 'Multi-device Deployment',
    desc: 'AR, VR, MR, Simulator and Web 3D Deployment',
    img: imagePath?.superChargeMUltiDeployment,
  },
  {
    title: 'Analytics',
    desc: 'Real-time reports on any experience you publish.',
    img: imagePath?.SuperChargeAnalytics,
  },
];

export const ToolsDetails = [
  {
    title: 'Drag & Drop',
    desc: 'Drag, drop, and edit assets, lighting, and environment.',
    img: gifsPath?.DragDrop,
  },
  {
    title: 'Industry Templates',
    desc: 'Streamline creation with customizable templates.',
    img: gifsPath?.IndustrialTemplate,
  },
  {
    title: 'Animation',
    desc: 'Give life to your 3d objects.',
    img: gifsPath?.Animation,
  },
  {
    title: 'Interactive Experiences',
    desc: 'Enable Interactivity on your objects',
    img: gifsPath?.Interaction,
  },
  {
    title: 'Material Layers',
    desc: 'Fine-tune the look of your models.',
    img: gifsPath?.MaterialChange,
  },
  {
    title: 'Physics',
    desc: 'Create real-time physics simulations & interactions.',
    img: gifsPath?.Physics,
  },
  {
    title: 'Game Controls',
    desc: 'Easily create 3rd person and 1st person experiences.',
    img: gifsPath?.Controler,
  },
  {
    title: 'Coding',
    desc: 'Inject 3JS or C# to embolden your experiences ',
    img: gifsPath?.Coding,
  },
];

export const superchargeData = [
  {
    video: videoPath?.FromConcept,
    title: 'From concept to creation, effortlessly',
    desc: 'Bring ideas to life effortlessly—drag, place, and structure spatial elements in real time. Watch your vision transform from concept to interactive environment with low to no zero code ',
  },
  {
    video: videoPath?.AccelerateWork,
    title: 'Accelerate your work',
    desc: 'Jumpstart your build using pre-made industry templates. Simply drag, drop, and position elements across the spatial grid to speed up workflows and publish immersive experiences faster than ever.',
  },
  {
    video: videoPath?.CollaborativeProject,
    title: 'Collaborative project work',
    desc: 'Work side-by-side with your team. Share tasks, co-create content, and communicate through the platform. Divide projects, assets and access through our teams feature. Stay aligned in real time—no handoffs, no context switching.',
  },
];

export const SuperChargeVideos = [
  {
    title: 'AR for Smartphones',
    desc: 'Bring your experiences to life in mobile AR with interactive 3D content overlaid onto the real world. Powered by plane, image, object, spatial, body/face, and location-based tracking, Spatial Grid’s AR lets users explore products, understand workflows, and interact with educational content in their environment. From marketing to product visualization to learning, AR delivers deeper engagement, clearer understanding, and smarter decisions through context-aware immersion.',
    videoSrc: videoPath?.ARAnatomy,
  },
  {
    title: 'VR  for Headsets',
    desc: 'Bring your experiences to life inside VR headsets with fully immersive, high-fidelity environments. Users can explore, train, and collaborate with unmatched presence. VR delivers deeper engagement, sharper spatial understanding, and more effective decision-making through hands-on, real-time immersion. Full controller or gesture interaction support and completely code-free.',
    videoSrc: videoPath?.VRHeadset,
  },
  {
    title: 'Experience Your Digital Twins — Alive, Interactive, Immersive.',
    desc: 'Bring your digital twins to life by seamlessly extending them into websites, simulations, VR, and MR environments. With immersive 3D interactivity, teams can explore, test, and visualize real-world systems in virtual space—enhancing understanding, accelerating decision-making, and unlocking deeper operational insights.',
    videoSrc: videoPath?.DigtalTwins,
  },
  {
    title: 'MR for Glasses',
    desc: 'Bring your experiences to life through MR glasses, blending real and virtual worlds with precise spatial anchoring. Using our award winning Spatial OS users can interact with 3D models, simulations, and live data as if they exist physically—unlocking advanced training, operational efficiency, and hands-on collaboration in mixed reality.',
    videoSrc: videoPath?.MRGlasses,
  },
];
